import { jsx, jsxs } from 'react/jsx-runtime';
import { BaseTileHeader, BaseTileTargetImage, FlexBox, Spinner, Icon, Typography, BaseTileImage } from '@vp/swan';
import { clsx } from '../../external/clsx/dist/clsx.js';
import { forwardRef } from 'react';
import styles from './template-tile.module.scss.js';

const TemplateTileImage = forwardRef((props, ref) => {
  const {
    alt,
    isLoading = false,
    accessibleTextForLoadingState,
    isError = false,
    onError,
    onLoad,
    src,
    srcSet,
    size = "Default" /* DEFAULT */,
    emptyPreviewText,
    className,
    renderComponent
  } = props;
  return /* @__PURE__ */ jsx(BaseTileHeader, { className, children: /* @__PURE__ */ jsxs(BaseTileTargetImage, { render: renderComponent, children: [
    isLoading && /* @__PURE__ */ jsx(FlexBox, { backgroundColor: "strong", alignItems: "center", justifyContent: "center", className: styles.templateTileSpinner, children: /* @__PURE__ */ jsx(Spinner, { accessibleText: accessibleTextForLoadingState, size: "standard" }) }),
    isError && /* @__PURE__ */ jsxs(
      FlexBox,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "strong",
        className: clsx(styles.templateTileFallbackPreview, { [styles.fallbackPreviewLarge]: size === "Large" /* LARGE */ }),
        children: [
          /* @__PURE__ */ jsx(Icon, { iconType: "image", size: "60p" }),
          /* @__PURE__ */ jsx(Typography, { component: "span", fontSkin: "body-standard-bold", py: "3", children: emptyPreviewText })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      BaseTileImage,
      {
        aspectRatio: 1,
        alt,
        className: clsx(styles.templateTileImage, {
          [styles.templateTileImageLarge]: size === "Large" /* LARGE */,
          [styles.templateTileImageHide]: isError
        }),
        ref,
        src,
        srcSet,
        onError,
        onLoad
      }
    )
  ] }) });
});

export { TemplateTileImage };
